import * as React from "react";
function SvgIcChevronLineRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.65 19.087L7 18.712l3.85-6.669L7 5.375 7.65 5l4.065 7.043-4.065 7.044zM15.477 5.188h.75V18.9h-.75V5.188z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronLineRight;
